import { Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';
import { UserService } from 'taxtank-core';

@Directive({
  selector: '[appAccessDisable]',
  standalone: false
})
export class AccessDisableDirective {
  private userService = inject(UserService);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  

  @Input() set appAccessDisable(userId: number) {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', userId !== this.userService.getCacheFirst().id);
  }
}
